// 栏数默认值
export const DEFAULT_COLUMN_NUMBER = 1;
// 栏数最小值
export const MIN_COLUMN_NUMBER = 1;
// 栏数最大值
export const MAX_COLUMN_NUMBER = 16;
// 栏数步长
export const COLUMN_NUMBER_STEP = 1;
// 栏数最大长度
export const MAX_COLUMN_NUMBER_LENGTH = 2;

// 栏间距默认值
export const DEFAULT_COLUMN_SPACE = 0;
// 栏间距最小值
export const MIN_COLUMN_SPACE = 0;
// 栏间距最大值
export const MAX_COLUMN_SPACE = 40.64;
// 栏间距步长
export const COLUMN_SPACE_STEP = 0.1;
// 栏间距最大长度
export const MAX_COLUMN_SPACE_LENGTH = 7;
